module.exports = __webpack_public_path__ + "img/icon-chrome.4833fd23.png";